import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Divider,
  FormControl,
  FormLabel,
  Input,
  Button,
  VStack,
  Select,
  SimpleGrid,
  Grid,
  Flex,
  Icon,
  Text,
  InputGroup,
  InputRightElement,
  useDisclosure,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  List,
  ListItem,
} from "@chakra-ui/react";
import {
  FaUser,
  FaList,
  FaUserShield,
  FaPlus,
  FaPrint,
  FaSync,
} from "react-icons/fa";
import axios from "axios";
import { StudentContext } from "../../Context/StudentContext";
import { useNavigate } from "react-router-dom";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../Globalapi/Globalapi";

const StudentForm = () => {
  const navigate = useNavigate();
  const { refreshStudents } = useContext(StudentContext);
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [bloodGroups, setBloodGroups] = useState([]);
  const [genders, setGenders] = useState([]);
  const [mediums, setMedium] = useState([]);
  const [guardians, setGuardians] = useState([]);
  const [filteredGuardians, setFilteredGuardians] = useState([]);
  const [showGuardianDropdown, setShowGuardianDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [classes, setClasses] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    address: "",
    date_of_birth: "",
    gender: "",
    blood_group: "",
    blood_group_name: "", // Store blood group name for display
    medium_name: "",
    gender_name: "",
    class_name: "",
    aadhar_no: "",
    image: "", // Base64 string for image
    medium: "",
    father_name: "",
    father_number: "",
    mother_name: "",
    mother_number: "",
    guardian: "", // Display selected guardian name
    guardian_id: "", // Store selected guardian ID for submission
    admission_number: "",
    class_id: "", // Store selected class ID
  });

  // Fetch classes from API
  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/class/class_master.php`
        );
        console.log("clas res", response);

        setClasses(response.data.data || []);
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };
    fetchClasses();
  }, []);
  useEffect(() => {
    axios
      .get(`${BASE_URL}/admin/staff/blood_group_master.php`)
      .then((response) => {
        console.log("Blood Groups:", response.data);
        setBloodGroups(response.data.data || []);
      })

      .catch((error) => console.error("Error fetching blood groups:", error));
    console.log("b", bloodGroups);

    axios
      .get(`${BASE_URL}/admin/staff/gender_master.php`)
      .then((response) => {
        console.log("gender Groups:", response.data);
        setGenders(response.data.data || []);
      })
      .catch((error) => console.error("Error fetching genders:", error));

    axios
      .get(`${BASE_URL}/admin/student/medium_master.php`)
      .then((response) => {
        console.log("medium :", response.data);

        setMedium(response.data.data || []);
      })
      .catch((error) => console.error("Error fetching mediums:", error));
  }, []);

  const handleChange = async (e) => {
    const { name, value } = e.target;

    if (name === "blood_group") {
      // Find the selected blood group object
      const selectedGroup = bloodGroups.find((group) => group.id === value);

      setFormData((prevState) => ({
        ...prevState,
        blood_group: value, // Store blood group ID
        blood_group_name: selectedGroup ? selectedGroup.group : "", // Store blood group name
      }));
    } else if (name === "gender") {
      // Find the selected gender object
      const selectedGender = genders.find((gender) => gender.id === value);

      setFormData((prevState) => ({
        ...prevState,
        gender: value, // Store gender ID
        gender_name: selectedGender ? selectedGender.gender : "", // Store gender name
      }));
    } else if (name === "class_id") {
      // Find the selected class object
      const selectedClass = classes.find((cls) => cls.id === value);

      setFormData((prevState) => ({
        ...prevState,
        class_id: value, // Store class ID
        class_name: selectedClass ? selectedClass.class : "", // Store class name
      }));
    } else if (name === "medium") {
      // Find the selected medium object
      const selectedMedium = mediums.find((med) => med.id === value);

      setFormData((prevState) => ({
        ...prevState,
        medium: value, // Store medium ID
        medium_name: selectedMedium ? selectedMedium.caption : "", // Store medium name
      }));
    } else if (name === "guardian") {
      setFormData((prevState) => ({ ...prevState, guardian: value }));
      fetchGuardians(value); // Fetch the guardians based on name input
    } else {
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData((prevState) => ({
        ...prevState,
        image: reader.result,
      }));
    };
    if (file) reader.readAsDataURL(file);
  };

  const handlePreview = () => {
    setShowPreview(true); // Display the preview modal
  };

  const validateEmail = (email) => {
    if (!email) return true; // no email entered → skip validation
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubmit = async () => {
    const {
      email,

      blood_group_name,
      gender_name,
      class_name,
      medium_name,
      guardian,
      ...rest
    } = formData;

    if (!validateEmail(email)) {
      toast({
        title: "Invalid Email",
        description: "Please enter a valid email address.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }
    const dataToSubmit = {
      ...rest,
      email,

      school_id: sessionStorage.getItem("school_id"),
      pass: sessionStorage.getItem("user_id"),
      guardian: formData.guardian_id, // Pass guardian ID for submission
    };

    console.log(dataToSubmit);

    try {
      const response = await axios.post(
        `${BASE_URL}/admin/student/create_student.php`,
        dataToSubmit
      );
      console.log("resp", response);

      if (response.data.success) {
        toast({
          title: "Success",
          description: "Data submitted successfully!",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        refreshStudents();
        setFormData({
          name: "",
          email: "",
          address: "",
          date_of_birth: "",
          gender: "",
          blood_group: "",
          blood_group_name: "",
          gender_name: "",
          class_name: "",
          medium_name: "",
          aadhar_no: "",
          image: "", // Base64 string for image
          medium: "",
          father_name: "",
          father_number: "",
          mother_name: "",
          mother_number: "",
          guardian: "", // Display selected guardian name
          guardian_id: "", // Store selected guardian ID for submission
          admission_number: "",
        });
        setShowPreview(false); // Hide preview after submitting
      } else {
        toast({
          title: "Error",
          description: response.data.message || "Failed to submit data!",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error(
        "Error submitting data:",
        error.response ? error.response.data : error.message
      );
      toast({
        title: "Error",
        description: "There was an error submitting the data.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const fetchGuardians = async (name) => {
    if (name.length === 0) {
      setFilteredGuardians([]);
      return;
    }

    try {
      const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

      const response = await axios.get(
        `${BASE_URL}/admin/guardian/list_all_guardian.php?school_id=${school_id}`,
        {
          params: { name },
        }
      );
      console.log(response);

      const guardiansData = response.data?.data || []; // Safely access data
      setGuardians(guardiansData);

      // Filter guardians based on the search term
      const filteredData = guardiansData.filter((guardian) =>
        guardian.name?.toLowerCase().startsWith(name.toLowerCase())
      );

      setFilteredGuardians(filteredData);
    } catch (error) {
      console.error("Error fetching guardians:", error);
    }
  };

  const handleGuardianSelect = (guardian) => {
    setFormData((prevState) => ({
      ...prevState,
      guardian: guardian.name, // Display the name in the input field
      guardian_id: guardian.id, // Store the ID for submission
    }));
    setSearchTerm(guardian.name); // Set the input value to the selected guardian name
    setShowGuardianDropdown(false); // Close dropdown after selection
  };
  const handleClick = () => {
    navigate("/students/all"); // Navigate to the desired route
  };
  return (
    <Box borderRadius="md" mx="auto">
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div
            className="header"
            style={{ display: "flex", alignItems: "center" }}
          >
            <h1 style={{ fontSize: "20px", margin: 0 }}>Add Student</h1>
            <div className="action-buttons" style={{ marginLeft: "auto" }}>
              <Button
                className="add-teacher-button"
                onClick={handleClick}
                leftIcon={<FaList />}
                colorScheme="teal" // Optional: You can customize the color scheme
              >
                <Box display={{ base: "none", md: "block" }}>Students</Box>
              </Button>
            </div>
          </div>

          <Box className="breadcrumb">
            <Link
              to="/admin"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <span>Dashboard</span>
            </Link>{" "}
            / <span>Students</span> / <span>Add Student</span>
          </Box>
        </div>
        <VStack spacing={4} align="stretch" p={7}>
          <Box width="100%" bg="#F2F5FF" p={1} borderRadius="md">
            <Flex align="center" mb={4} mt={2} ml={2}>
              <Icon as={FaUser} boxSize={6} color="teal" mr={2} />
              <Text fontSize="lg" fontWeight="bold">
                Personal Information
              </Text>
            </Flex>
          </Box>
          <Grid
            templateColumns={{ base: "1fr", lg: "repeat(4, 1fr)" }}
            gap={6}
            mb={6}
            p={2}
          >
            <FormControl id="name" isRequired>
              <FormLabel>Name</FormLabel>
              <Input
                type="text"
                placeholder="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl id="email" isRequired>
              <FormLabel>Email</FormLabel>
              <Input
                type="email"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl id="address" isRequired>
              <FormLabel>Address</FormLabel>
              <Input
                type="text"
                placeholder="Address"
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl id="date_of_birth" isRequired>
              <FormLabel>Date of Birth</FormLabel>
              <Input
                type="date"
                name="date_of_birth"
                value={formData.date_of_birth}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl id="gender" isRequired>
              <FormLabel>Gender</FormLabel>
              <Select
                placeholder="Select Gender"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                {genders.map((gender) => (
                  <option key={gender.id} value={gender.id}>
                    {gender.gender}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl id="class" isRequired>
              <FormLabel>Select Class</FormLabel>
              <Select
                placeholder="Select Class"
                name="class_id"
                value={formData.class_id}
                onChange={handleChange}
              >
                {classes.map((cls) => (
                  <option key={cls.id} value={cls.id}>
                    {cls.class}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl id="blood_group" isRequired>
              <FormLabel>Blood Group</FormLabel>
              <Select
                placeholder="Select Blood Group"
                name="blood_group"
                value={formData.blood_group}
                onChange={handleChange}
              >
                {bloodGroups.map((group) => (
                  <option key={group.id} value={group.id}>
                    {group.group}
                  </option>
                ))}
              </Select>
            </FormControl>

            <FormControl id="aadhar_no" isRequired>
              <FormLabel>Aadhar Number</FormLabel>
              <Input
                type="text"
                placeholder="Aadhar Number"
                name="aadhar_no"
                value={formData.aadhar_no}
                onChange={handleChange}
              />
            </FormControl>
          </Grid>

          {/* <Divider borderColor="gray.300" borderStyle="dotted" /> */}

          <Box>
            <Grid
              templateColumns={{ base: "1fr", lg: "repeat(4, 1fr)" }}
              gap={6}
              mb={6}
              p={2}
            >
              <FormControl id="admission_number" isRequired>
                <FormLabel>Admission No</FormLabel>
                <Input
                  placeholder="Admission No"
                  value={formData.admission_number}
                  name="admission_number"
                  onChange={handleChange}
                />
              </FormControl>

              <FormControl id="image">
                <FormLabel>Upload Image</FormLabel>
                <Input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </FormControl>

              <FormControl id="medium" isRequired>
                <FormLabel>Medium</FormLabel>
                <Select
                  placeholder="Select Medium"
                  name="medium"
                  value={formData.medium}
                  onChange={handleChange}
                >
                  {mediums.map((medium) => (
                    <option key={medium.id} value={medium.id}>
                      {medium.caption}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl id="father_name" isRequired>
                <FormLabel>Father Name</FormLabel>
                <Input
                  placeholder="Father Name"
                  name="father_name"
                  value={formData.father_name}
                  onChange={handleChange}
                />
              </FormControl>

              <FormControl id="mother_name" isRequired>
                <FormLabel>Mother Name</FormLabel>
                <Input
                  placeholder="Mother Name"
                  name="mother_name"
                  value={formData.mother_name}
                  onChange={handleChange}
                />
              </FormControl>

              <FormControl id="father_number" isRequired>
                <FormLabel>Father Number</FormLabel>
                <Input
                  placeholder="Father Number"
                  name="father_number"
                  value={formData.father_number}
                  onChange={handleChange}
                />
              </FormControl>

              <FormControl id="mother_number" isRequired>
                <FormLabel>Mother Number</FormLabel>
                <Input
                  placeholder="Mother Number"
                  name="mother_number"
                  value={formData.mother_number}
                  onChange={handleChange}
                />
              </FormControl>

              <FormControl id="guardian" isRequired>
                <FormLabel>Guardian Name</FormLabel>
                <InputGroup>
                  <Input
                    placeholder="Search Guardian"
                    onChange={handleChange}
                    name="guardian"
                    value={formData.guardian}
                    onFocus={() => setShowGuardianDropdown(true)}
                  />
                  <InputRightElement>
                    <Button
                      size="sm"
                      colorScheme="teal"
                      onClick={() => navigate("/guardians/add")}
                      // onClick={onOpen}
                    >
                      +
                    </Button>
                  </InputRightElement>
                </InputGroup>

                {showGuardianDropdown && (
                  <Box
                    border="1px solid #ccc"
                    borderRadius="md"
                    mt={1}
                    maxH="150px"
                    overflowY="auto"
                    bg="white"
                    zIndex={1}
                    position="absolute"
                    width="100%"
                  >
                    {filteredGuardians.length > 0 ? (
                      <List spacing={0}>
                        {filteredGuardians.map((guardian) => (
                          <ListItem
                            key={guardian.id}
                            p={2}
                            _hover={{
                              backgroundColor: "gray.100",
                              cursor: "pointer",
                            }}
                            onClick={() => handleGuardianSelect(guardian)}
                          >
                            {guardian.name}
                          </ListItem>
                        ))}
                      </List>
                    ) : (
                      <Text p={2}>No guardians found</Text>
                    )}
                  </Box>
                )}
              </FormControl>
            </Grid>
          </Box>

          <Button colorScheme="teal" onClick={handleSubmit}>
            Submit
          </Button>
          <Button
            colorScheme="teal"
            onClick={handlePreview}
            size="md" // Small button size
            ml="auto" // Align to the right side of the container
          >
            Preview
          </Button>

          {/* <AddGuardianModal isOpen={isOpen} onClose={onClose} /> */}
          {/* Preview Modal */}
          {showPreview && (
            <Modal
              isOpen={showPreview}
              onClose={() => setShowPreview(false)}
              size="lg"
              motionPreset="slideInBottom"
            >
              <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
              <ModalContent
                borderRadius="lg"
                boxShadow="xl"
                bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
                color="gray.700"
                p={6}
                maxW="700px"
                maxH="550px"
                overflowY="auto"
                // minW={{ base: "95%", md: "800px", lg: "800px" }}
              >
                <ModalHeader
                  fontSize="xl"
                  fontWeight="bold"
                  textAlign="center"
                  color="teal.600"
                >
                  Preview for Add Student
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody
                  overflowY="auto"
                  px={4}
                  css={{
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "rgba(255, 255, 255, 0.2)",
                      borderRadius: "10px",
                      backdropFilter: "blur(8px)",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "rgba(173, 216, 230, 0.6)",
                      borderRadius: "10px",
                      backdropFilter: "blur(8px)",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "rgba(173, 216, 230, 0.9)",
                    },
                  }}
                >
                  {/* Personal Information Section */}
                  {/* <Box width="100%" bg="#F2F5FF" p={1} borderRadius="md">
                    <Flex align="center" mb={4} mt={2} ml={2}>
                      <Icon as={FaUser} boxSize={6} color="teal" mr={2} />
                      <Text fontSize="lg" fontWeight="bold">
                        Personal Information
                      </Text>
                    </Flex>
                  </Box> */}

                  <Box maxHeight="600px" p={4}>
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                      {/* Personal Information Fields */}
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Name:
                          </Text>
                          <Text>{formData.name}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Email:
                          </Text>
                          <Text>{formData.email}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Address:
                          </Text>
                          <Text>{formData.address}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Date of Birth:
                          </Text>
                          <Text>{formData.date_of_birth}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Gender:
                          </Text>
                          <Text>{formData.gender_name}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Class:
                          </Text>
                          <Text>{formData.class_name}</Text>
                        </Flex>
                      </Box>
                      {/* 
                      <Divider
                        my={6}
                        borderColor="gray.300"
                        borderStyle="dotted"
                      /> */}

                      {/* Additional Information Fields */}

                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Blood Group:
                          </Text>
                          <Text>{formData.blood_group_name}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Aadhar No:
                          </Text>
                          <Text>{formData.aadhar_no}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Admission No:
                          </Text>
                          <Text>{formData.admission_number}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Medium:
                          </Text>
                          <Text>{formData.medium_name}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Father's Name:
                          </Text>
                          <Text>{formData.father_name}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Mother's Name:
                          </Text>
                          <Text>{formData.mother_name}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Father Number:
                          </Text>
                          <Text>{formData.father_number}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Mother Number:
                          </Text>
                          <Text>{formData.mother_number}</Text>
                        </Flex>
                      </Box>
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Guardian:
                          </Text>
                          <Text>{formData.guardian}</Text>
                        </Flex>
                      </Box>

                      {/* Image Preview */}
                      <Box whiteSpace="nowrap" minW="300px">
                        <Flex align="center">
                          <Text fontWeight="semibold" minW="120px">
                            Profile Image:
                          </Text>
                          {formData.image ? (
                            formData.image instanceof File ? (
                              <img
                                src={URL.createObjectURL(formData.image)}
                                alt="Profile"
                                width="100"
                              />
                            ) : (
                              <img
                                src={formData.image}
                                alt="Profile"
                                width="100"
                              />
                            )
                          ) : (
                            "No image uploaded"
                          )}
                        </Flex>
                      </Box>
                    </SimpleGrid>
                  </Box>

                  <ModalFooter>
                    <Button colorScheme="teal" mr={3} onClick={handleSubmit}>
                      Proceed & Submit
                    </Button>
                    {/* <Button
                      variant="ghost"
                      onClick={() => setShowPreview(false)}
                    >
                      Cancel
                    </Button> */}
                  </ModalFooter>
                </ModalBody>
              </ModalContent>
            </Modal>
          )}
        </VStack>
      </div>
    </Box>
  );
};

// const AddGuardianModal = ({ isOpen, onClose }) => {
//   const [nations, setNations] = useState([]);
//   const [states, setStates] = useState([]);
//   const [districts, setDistricts] = useState([]);
//   const [guardianFormData, setGuardianFormData] = useState({
//     name: "",
//     address: "",
//     email: "",
//     contact_no: "",
//     nation: "",
//     state: "",
//     relation: "",
//     district: "",
//     place: "",
//     username: "",
//     password: "",
//     confirm_password: "",
//   });
//   const toast = useToast();

//   useEffect(() => {
//     axios
//       .get(`${BASE_URL}/admin/staff/nation_master.php`)
//       .then((response) => setNations(response.data.data || []))
//       .catch((error) => console.error("Error fetching nations:", error));
//   }, []);

//   useEffect(() => {
//     if (guardianFormData.nation) {
//       axios
//         .get(`${BASE_URL}/admin/staff/state_master.php`)
//         .then((response) => {
//           const filteredStates = response.data.data.filter(
//             (state) => state.nation_id === guardianFormData.nation
//           );
//           setStates(filteredStates);
//         })
//         .catch((error) => console.error("Error fetching states:", error));
//     } else {
//       setStates([]);
//       setDistricts([]);
//     }
//   }, [guardianFormData.nation]);

//   useEffect(() => {
//     if (guardianFormData.state) {
//       // Use POST request since the PHP script expects it
//       axios
//         .post(
//           `${BASE_URL}/admin/staff/district_master.php`,
//           { state_id: guardianFormData.state }, // Pass state_id in the body
//           {
//             headers: {
//               "Content-Type": "application/json", // Ensure proper headers
//             },
//           }
//         )
//         .then((response) => {
//           if (response.data && response.data.data) {
//             setDistricts(response.data.data); // Set districts from response
//           } else {
//             setDistricts([]); // Clear districts if no data
//             console.error("Districts data is empty or undefined:", response);
//           }
//         })
//         .catch((error) => console.error("Error fetching districts:", error));
//     } else {
//       setDistricts([]); // Clear districts if no state is selected
//     }
//   }, [guardianFormData.state]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setGuardianFormData((prevState) => ({ ...prevState, [name]: value }));
//   };

//   const handleSubmit = async () => {
//     try {
//       const response = await axios.post(
//         `${BASE_URL}/admin/guardian/create_guardian.php`,
//         {
//           ...guardianFormData,
//           school_id: sessionStorage.getItem("school_id"), // School ID

//           pass: sessionStorage.getItem("user_id"),
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.data.success === false) {
//         toast({
//           title: "Error",
//           description: response.data.message,
//           status: "error",
//           duration: 5000,
//           isClosable: true,
//         });
//       } else {
//         toast({
//           title: "Success",
//           description: response.data.message,
//           status: "success",
//           duration: 5000,
//           isClosable: true,
//         });
//         onClose();
//       }
//     } catch (error) {
//       console.error(
//         "Error creating guardian:",
//         error.response ? error.response.data : error.message
//       );
//       toast({
//         title: "Error",
//         description:
//           "There was an error creating the guardian. " +
//           (error.response?.data?.message || error.message),
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   };

//   return (
//     <Modal isOpen={isOpen} onClose={onClose}>
//       <ModalOverlay />
//       <ModalContent>
//         <ModalHeader>Add Guardian Details</ModalHeader>
//         <ModalCloseButton />
//         <ModalBody>
//           <FormControl id="name" isRequired mb={4}>
//             <FormLabel>Name</FormLabel>
//             <Input
//               name="name"
//               value={guardianFormData.name}
//               onChange={handleChange}
//             />
//           </FormControl>
//           <FormControl id="address" isRequired mb={4}>
//             <FormLabel>Address</FormLabel>
//             <Input
//               name="address"
//               value={guardianFormData.address}
//               onChange={handleChange}
//             />
//           </FormControl>
//           <FormControl id="email" isRequired mb={4}>
//             <FormLabel>Email</FormLabel>
//             <Input
//               type="email"
//               name="email"
//               value={guardianFormData.email}
//               onChange={handleChange}
//             />
//           </FormControl>
//           <FormControl id="relation" isRequired mb={4}>
//             <FormLabel>Relation</FormLabel>
//             <Input
//               name="relation"
//               value={guardianFormData.relation}
//               onChange={handleChange}
//             />
//           </FormControl>
//           <FormControl id="contact_no" isRequired mb={4}>
//             <FormLabel>Contact No</FormLabel>
//             <Input
//               name="contact_no"
//               value={guardianFormData.contact_no}
//               onChange={handleChange}
//             />
//           </FormControl>
//           <FormControl id="nation" isRequired mb={4}>
//             <FormLabel>Nation</FormLabel>
//             <Select
//               name="nation"
//               value={guardianFormData.nation}
//               onChange={handleChange}
//             >
//               <option value="">Select Nation</option>
//               {nations.map((nation) => (
//                 <option key={nation.id} value={nation.id}>
//                   {nation.nation}
//                 </option>
//               ))}
//             </Select>
//           </FormControl>
//           <FormControl id="state" isRequired mb={4}>
//             <FormLabel>State</FormLabel>
//             <Select
//               name="state"
//               value={guardianFormData.state}
//               onChange={handleChange}
//               disabled={!guardianFormData.nation}
//             >
//               <option value="">Select State</option>
//               {states.map((state) => (
//                 <option key={state.id} value={state.id}>
//                   {state.state}
//                 </option>
//               ))}
//             </Select>
//           </FormControl>
//           <FormControl id="district" isRequired mb={4}>
//             <FormLabel>District</FormLabel>
//             <Select
//               name="district"
//               value={guardianFormData.district}
//               onChange={handleChange}
//               disabled={!guardianFormData.state}
//             >
//               <option value="">Select District</option>
//               {districts.map((district) => (
//                 <option key={district.id} value={district.id}>
//                   {district.district}
//                 </option>
//               ))}
//             </Select>
//           </FormControl>
//           <FormControl id="place" isRequired mb={4}>
//             <FormLabel>Place</FormLabel>
//             <Input
//               name="place"
//               value={guardianFormData.place}
//               onChange={handleChange}
//             />
//           </FormControl>
//           <FormControl id="username" isRequired mb={4}>
//             <FormLabel>Username</FormLabel>
//             <Input
//               name="username"
//               value={guardianFormData.username}
//               onChange={handleChange}
//             />
//           </FormControl>
//           <FormControl id="password" isRequired mb={4}>
//             <FormLabel>Password</FormLabel>
//             <Input
//               type="password"
//               name="password"
//               value={guardianFormData.password}
//               onChange={handleChange}
//             />
//           </FormControl>
//           <FormControl id="confirm_password" isRequired mb={4}>
//             <FormLabel>Confirm Password</FormLabel>
//             <Input
//               type="password"
//               name="confirm_password"
//               value={guardianFormData.confirm_password}
//               onChange={handleChange}
//             />
//           </FormControl>
//         </ModalBody>
//         <ModalFooter>
//           <Button colorScheme="teal" mr={3} onClick={handleSubmit}>
//             Save
//           </Button>
//           <Button variant="ghost" onClick={onClose}>
//             Close
//           </Button>
//         </ModalFooter>
//       </ModalContent>
//     </Modal>
//   );
// };

export default StudentForm;
